// @ts-nocheck
import { Plus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { MouseEventHandler, ReactNode } from 'react';

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
  label?: string;
  icon?: ReactNode;
  className?: string;
};

export const MobileFab = ({ onClick, label, icon, className }: Props) => {
  return (
    <button
      onClick={onClick}
      aria-label={label || 'Adicionar'}
      className={cn(
        'fixed right-4 z-30 h-14 rounded-full bg-primary text-primary-foreground shadow-xl shadow-primary/30 flex items-center justify-center gap-2 active:scale-95 transition-transform',
        label ? 'px-5' : 'w-14',
        className,
      )}
      style={{
        bottom: 'calc(88px + env(safe-area-inset-bottom))',
      }}
    >
      {icon ?? <Plus className="h-6 w-6" />}
      {label && <span className="font-semibold text-sm">{label}</span>}
    </button>
  );
};
